import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || '';

/**
 * Service for document review operations
 */
export default {
  /**
   * Get document details including image URL and extracted fields
   * @param {string} documentId - The ID of the document
   * @returns {Promise} - Promise with document data
   */
  async getDocument(documentId) {
    try {
      const response = await axios.get(`${API_URL}/api/v1/documents/${documentId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching document:', error);
      throw error;
    }
  },

  /**
   * Get document image
   * @param {string} documentId - The ID of the document
   * @returns {Promise} - Promise with document image data
   */
  getDocumentImageUrl(documentId) {
    return `${API_URL}/api/v1/documents/${documentId}/image`;
  },

  /**
   * Save document review changes
   * @param {string} documentId - The ID of the document
   * @param {Array} changes - Array of field changes
   * @param {Array} auditTrail - Array of audit trail entries
   * @returns {Promise} - Promise with save result
   */
  async saveChanges(documentId, changes, auditTrail) {
    try {
      const response = await axios.post(`${API_URL}/api/v1/documents/${documentId}/review`, {
        changes,
        auditTrail
      });
      return response.data;
    } catch (error) {
      console.error('Error saving document changes:', error);
      throw error;
    }
  },

  /**
   * Get document audit trail
   * @param {string} documentId - The ID of the document
   * @returns {Promise} - Promise with audit trail data
   */
  async getAuditTrail(documentId) {
    try {
      const response = await axios.get(`${API_URL}/api/v1/documents/${documentId}/audit-trail`);
      return response.data;
    } catch (error) {
      console.error('Error fetching audit trail:', error);
      throw error;
    }
  }
};